import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  public pageTitle = 'Welcome!';

  constructor(
    private platform: Platform,
  ) {
    this.platform.ready().then(() => {
      const splash = document.getElementById('splash-screen');
      setTimeout(() => {
        splash.remove();
      }, 2000);
    });
  }
}
